import {createApp, createVNode, render} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入Vant
import Vant from 'vant'
import {Dialog} from 'vant'

import 'vant/lib/index.css'
import 'amfe-flexible'
// 路由守卫
import './router/permission'

import './assets/css/index.css'
import './assets/css/comm.less'
import './assets/css/custom.less'
import './assets/css/variables.less'
import './assets/css/normalize.css'

// 标题组件
import CommonTitle from '@/components/CommonTitle.vue'

import {d_has, d_fileDownload, d_imgPreview, d_debounce} from '@/utils/directive'
import {d_dict, d_dictValue} from '@/utils/dictValue'
const app = createApp(App)
app.component('CommonTitle', CommonTitle)

app.directive('debounce', d_debounce.bind)
app.directive('has', d_has.bind)
app.directive('fileDownload', d_fileDownload.bind)
app.directive('imgPreview', d_imgPreview.bind)
app.directive('dict', d_dict.bind)
app.directive('dictValue', d_dictValue.bind)

app
    .use(store)
    .use(router)
    .use(store)
    .use(Vant)
    .use(Dialog)
    .mount('#app')
export default app;
